import { ValidationTextFieldProps } from '../../ValidationTextField';

export type ModalTextInputProps = {
  label: string;
  inputProps: ValidationTextFieldProps;
  testId?: string;
};

export { default as ModalTextInput } from './ModalTextInput';
